import alertBodyTypes from 'modules/_shared/components/Alert/alertBodyTypes';
import { addAlert } from 'modules/_shared/redux/alertActions';
import { ErrorResponse } from 'react-router';

import { Dispatch } from 'redux';
import Swal, { SweetAlertOptions } from 'sweetalert2';

const getAlertBody = (response: ErrorResponse) => {
  if (response.status !== 400) return;

  if (response.data?.message) {
    const bodyKey = response.data.message as keyof typeof alertBodyTypes;
    return alertBodyTypes?.[bodyKey] || alertBodyTypes[400];
  }

  return alertBodyTypes[400];
};

export const dispatchError = (error: any, dispatch: Dispatch) => {
  if (error?.response?.status === 403) {
    return;
  }

  if (error?.response?.status === 400) {
    return dispatch(addAlert(getAlertBody(error.response)));
  }

  if (error?.response?.status === 429) {
    return Swal.fire({ ...(alertBodyTypes[429] as SweetAlertOptions) }).then(
      async (result) => {
        if (result.isConfirmed) {
          window.location.reload();
        }
      }
    );
  }

  return null;
  // return dispatch(addAlert(alertBodyTypes[500]));
};
